import React, { FC, ReactElement, Suspense, lazy } from 'react';
import { Field, FieldProps, FormikProps } from 'formik';

import LoadingSpinner from 'buyside/components/presentation/LoadingSpinner/loadingSpinner';

const TinyMCEEditor = lazy(() =>
  import('buyside/components/presentation/TinyMCEEditor/tinyMceEditor')
);

export const NotesField: FC<{ field: FieldProps['field']; form: FormikProps<any> }> = ({
  field,
  form: { setFieldValue, isSubmitting }
}) => {
  const onEditorChange = (value: string): void => setFieldValue(field.name, value);

  return (
    <Suspense fallback={<LoadingSpinner />}>
      <TinyMCEEditor
        id={field.name}
        disabled={isSubmitting}
        onEditorChange={onEditorChange}
        value={field.value || ''}
      />
    </Suspense>
  );
};

const NotesForm = (): ReactElement => <Field component={NotesField} name="fundProfile.notes" />;

export default NotesForm;
